import { trackingService } from '@monthio/react-components'
import { useEffect } from 'react'

import type { TransactionDataValidationStatus } from '../../../Bank.types'

import { AccessibleAccountsPrompt } from './AccessibleAccountsPrompt'

export interface MissingAccountsPromptProps {
	onOpenChange: (isOpen: boolean) => void
	clientName: string
	banksToAdd: string[]
	handleContinue: () => void
	handleAddMoreBanks: () => void
	triggerReasones: TransactionDataValidationStatus
}

export const MissingAccountsPrompt = (
	props: MissingAccountsPromptProps,
): JSX.Element | null => {
	useEffect(() => {
		let additionalData = { ...props.triggerReasones } as Record<
			string,
			boolean | string
		>

		if (props.banksToAdd.length > 0) {
			additionalData = {
				...additionalData,
				suggestedBanksToAdd: props.banksToAdd.join(', '),
			}
		}

		trackingService.trackEvent('missingAccountsPromptTriggered', additionalData)
	}, [])

	return (
		<AccessibleAccountsPrompt
			onOpenChange={props.onOpenChange}
			clientName={props.clientName}
			handleContinue={props.handleContinue}
			handleAddMoreBanks={props.handleAddMoreBanks}
			banksToAdd={props.banksToAdd}
		/>
	)
}
